export default class Answer {
  constructor (value, errorMessage, values = []) {
    this.errorMessage = errorMessage
    this.value = value
    this.values = values
  }
}
